import React, { useState } from 'react';
import { CardHeader } from '../CardHeader';
import { Surface, Body, FullBleed, Footer, Section } from './styled';
const collapseAnimationVariants = {
    expanded: { height: 'auto' },
    collapsed: { height: 0 },
};
export const Card = ({ className, style, title, subtitle, HeaderActionSlot, action, collapsable, elevation, accent, children, onClose, renderFooter, }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const toggleCollapsed = () => {
        setIsCollapsed(!isCollapsed);
    };
    const headerMarkup = title && (React.createElement(CardHeader, { title: title, subtitle: subtitle, ActionSlot: HeaderActionSlot, action: action, onClickClose: onClose, isCollapsed: isCollapsed, onClickCollapse: collapsable ? toggleCollapsed : undefined }));
    const showBody = (collapsable && !isCollapsed) || !collapsable;
    const bodyMarkup = (React.createElement(Body, { animate: showBody ? 'expanded' : 'collapsed', variants: collapseAnimationVariants, transition: { duration: 0.3, ease: 'easeOut' } },
        React.createElement(Section, null, children)));
    const footerMarkup = renderFooter !== undefined && React.createElement(Footer, null, renderFooter());
    return (React.createElement(Surface, { className: className, style: style, elevation: elevation, accent: accent },
        headerMarkup,
        bodyMarkup,
        footerMarkup));
};
Card.Surface = Surface;
Card.Section = Section;
Card.FullBleed = FullBleed;
Card.Footer = Footer;
//# sourceMappingURL=Card.js.map